import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const RemoteEventSchema = withDefaults({
  type: 'remote-event',
  fields: [
    {
      kind: 'attribute',
      name: 'eventType',
    },
    {
      kind: 'attribute',
      name: 'payload',
    },
    {
      kind: 'attribute',
      name: 'at',
    },
    {
      kind: 'belongsTo',
      name: 'user',
      type: 'user',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default RemoteEventSchema;
